<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <vsud-alert v-if="showAlert" icon="fa fa-bell" dismissible="true" color="success">
            {{ msgAlert }}
        </vsud-alert>
        <businesslocation-table></businesslocation-table>
      </div>
    </div>
  </div>
</template>

<script>
import BusinesslocationTable from "@/views/businesslocation/components/Table.vue";
import VsudAlert from "@/components/VsudAlert.vue";

export default {
  name: "trade-types",
  data()
  {
    return {
      showAlert : false,
      msgAlert  : '',
      name : 'Business location',
    }
  },

  created ()
  {
    this.checkAlert();
  },

  components: 
  {
    BusinesslocationTable,
    VsudAlert
  },

  methods : 
  {
    checkAlert()
    {
      const status = this.$route.params.status;
      const token  = this.$store.state.alertToken;

      if(token==status&&token!='')
      {
        this.showAlert = true;
        this.msgAlert  = this.name+' addedd successfully';
        this.$store.dispatch('setAlertToken', '');
      }
    }
  }
};
</script>